export default function initStyles() {
  const objectPosition = document.querySelectorAll<HTMLElement>('.js-object-position');
  const isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.objectPosition = el.dataset.objectPosition as string;
    const { objectPositionMobile } = el.dataset;
    if (objectPositionMobile && isTouchDevice) {
      // eslint-disable-next-line no-param-reassign
      el.style.objectPosition = objectPositionMobile;
    }
  });
}
